import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

export default function Addon(props) {

    const designer = useDesigner();

    const toJson = useCallback(() => {

        designer.getThumb().then(data => {
            console.log(data);
        });

    }, [designer]);

    return <>
        <div className='layout-h center' onClick={toJson}>
            <Application.SystemSvgIcon type="image" style={{ fontSize: 20, marginRight: 7 }} />
            导出为图片
        </div>
    </>
}